import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {GenAIService} from "services/GenAIService";
import {RateSummaryAttributes} from "typing/dto";

export interface RateSummaryState {
    data: RateSummaryAttributes | null;
    loading: boolean;
    error: string | null;
}

const initialState: RateSummaryState = {
    data: null,
    loading: false,
    error: null,
};

export const fetchRateSummary = createAsyncThunk("rateSummary/fetchRateSummary", async (unitId: number) => {
    const response = await GenAIService.getInstance().getRateSummaryByUnitId(unitId);
    return response;
});

const rateSummarySlice = createSlice({
    name: "rateSummary",
    initialState,
    reducers: {
        clearRateSummary: (state) => {
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRateSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRateSummary.fulfilled, (state, action: PayloadAction<RateSummaryAttributes>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchRateSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch rate summary";
            });
    },
});

export const {clearRateSummary} = rateSummarySlice.actions;
export default rateSummarySlice.reducer;
